import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { BillingInformationContext } from "../BillingInformationContext";
import { useBillingInformation } from "../Shared/hooks/useBillingInformation/useBillingInformation";
import { BillingInfoText } from "../BillingInformation-types";
import { ResponsiveTable } from "../../../Shared/components/ResponsiveTable";
import { buildCreditCardTable } from "./";
const CreditCardTable = ({ usingStripe, setSelectedCard, setIsRemoveCardModalOpen, createSetupIntentForCard, setupIntentLoading, selectedCard, }) => {
    const { token, publicKey, customerCreditCards, authorizeUrl } = useContext(BillingInformationContext);
    const { primaryPaymentMethodToggle } = useBillingInformation();
    const usingStripeOrTap = usingStripe || !!publicKey;
    const { columns, rows } = buildCreditCardTable({
        cards: customerCreditCards || [],
        usingStripeOrTap,
        setupIntentLoading,
        token: token === null || token === void 0 ? void 0 : token.toString(),
        selectedCard,
        authorizeUrl,
        onEditCard: (cardId) => {
            createSetupIntentForCard(cardId);
            const card = customerCreditCards === null || customerCreditCards === void 0 ? void 0 : customerCreditCards.find((c) => c.id === cardId);
            if (card)
                setSelectedCard(card);
        },
        onRemoveCard: (card) => {
            setSelectedCard(card);
            setIsRemoveCardModalOpen(true);
        },
        onPrimaryToggle: primaryPaymentMethodToggle,
        setSelectedCard,
    });
    return (_jsx(ResponsiveTable, { collapsible: true, defaultExpanded: true, caption: BillingInfoText.CREDIT_DEBIT, columns: columns, rows: rows, noDataMessage: BillingInfoText.NO_PAYMENT_METHODS_AVAILABLE }));
};
export default CreditCardTable;
